<template>
    <div class="max-w-sm mx-auto mt-257 px-12 md:px-0">
        <Title
            :title="$t('loginFormTitle')"
            :subtitle="$t('loginFormSubtitle')"
        />

        <!-- General error message -->
        <p
            v-if="error"
            class="text-red-500 small my-10"
        >
            {{error}}
        </p>

        <p v-if="errors">{{errors.error}}</p>

        <form
            @submit.prevent="onSubmit"
            ref="loginInitForm"
        >
            <Input
                class="mb-22"
                :error="errors.email"
                :label="$t('emailFieldLabel')"
                :placeholder="$t('emailFieldPlaceholder')"
                type="email"
                name="email"
            />

            <Input
                class="mb-22"
                :error="errors.password"
                :label="$t('passwordFieldLabel')"
                :placeholder="$t('passwordFieldPlaceholder')"
                change=""
                type="password"
                name="password"
            />

            <p class="font-semibold text-purple-500 underline mb-20">
                <router-link :to='{name:"ResetPasswordInit"}'>
                    {{$t('loginFormResetPasswordLinkText')}}
                </router-link>
            </p>

            <div class="w-full flex justify-center mb-36">
                <Button
                    class="button bg-purple-500 text-white hover:bg-purple-600 font-bold"
                    role="submit"
                    :text="$t('loginButtonText')"
                    :disabled="loginLoading"
                    :spinning="loginLoading"
                />
            </div>
        </form>

        <div class="flex justify-center">
            <p>
                {{$t('loginNoAccountText')}}
                <router-link
                    class="font-semibold text-purple-500 underline"
                    to="/signup"
                >{{$t('loginNoAccountRegisterLinkText')}}</router-link>
            </p>
        </div>
    </div>
</template>

<script>
import Input from '@/components/form/Input'
import Button from '@/components/buttons/Button'
import Title from '@/components/texts/FormTitle'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'Login',

    components: {
        Input,
        Button,
        Title
    },

    data () {
        return {
            loginLoading: false
        }
    },

    computed: {
        /** Get vuex state */
        ...mapGetters(['errors', 'error', 'token', 'userType'])
    },

    methods: {
        /** Vuex actions. */
        ...mapActions(['loginInit']),

        /** Login init form. */
        onSubmit () {
            this.loginLoading = true

            const payload = {
                email: this.$refs.loginInitForm.email.value,
                password: this.$refs.loginInitForm.password.value
            }

            this.loginInit(payload)
                .then(() => {
                    this.loginLoading = false
                })
        }
    }
}
</script>
